import React, { Component } from 'react';

class Bamboo extends Component {
  constructor (props) {
    super(props)
  }

componentDidMount() {
  (function() {

  var divId="BambooHR-ATS";
  var el=document.getElementById(divId);
  if(!el) {
    document.write("<div id=\""+divId+"\"></div>");
  }
  
  //var myUrl = 'https://bethard.bamboohr.co.uk/jobs/embed2.php';
  var myUrl = 'https://betharduniverse.com/jobs.html';

  // Use corse-anywhere to bypass CORS
  var proxy = ''//'https://cors-anywhere.herokuapp.com/';

  // Execute request
  var oReq = new XMLHttpRequest();

  oReq.open("GET", proxy + myUrl);
  oReq.send();

    oReq.onreadystatechange=function() {
      if(oReq.readyState==4 && oReq.status==200) {
        var content = oReq.responseText;
        var footerId="BambooHR-Footer";
        var fel=document.getElementById(footerId);

        // adding target blank before each href
        content = content.replace(/href/g, "target='_blank' href");

        el=document.getElementById(divId);

        if(el && !fel) {
          content += "<div id=\"BambooHR-Footer\">Powered by <a href=\"http://www.bamboohr.com\" target=\"_blank\" rel=\"external\"><img src=\"https://resources.bamboohr.com/images/footer-logo.png\" alt=\"BambooHR - HR software\"/></a></div>";
        }
        if(el) el.innerHTML=content;

      }
  }

  }) ();
  }

  render() {
    return (
        <div><div id="BambooHR-ATS"></div><p><a style={{fontWeight:"bold",fontSize:"22px",color:"#b9bfb9",textDecoration:"none"}} href='https://bethard.bamboohr.com/jobs/'>View our open positions here →</a></p></div>
    );
  }
}

export default Bamboo;



// WEBPACK FOOTER //
// ./client/components/bamboo.jsx